import { Fragment } from 'react';

import useLSCReportingReports from './UseLSCReportingReports';

import ReportList from '@usas/ui-web/components/embeddedReports/ReportList';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

import global from '@usas/ui-web/components/GlobalStyle.module.css'

const LSCReportingReports = () => {
  const {
    reportParameters,
    orgUnitId,
    orgUnitName,
    routeName,
    selectOrgUnitState,
    onBackToSelectionClicked
  } = useLSCReportingReports();

  if (!orgUnitId) {
    return (
      <Fragment>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PageNotFound />
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      {selectOrgUnitState.showBackToSelection &&
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>}
      <div className="row">
        <div className="col-xs-12 usas-extra-bottom-margin">
          <p className={global.HeaderText}><strong>Viewing:</strong> {orgUnitName}</p>
        </div>
      </div>
      <ReportList listTitle="LSC Reports"
        routeName={routeName}
        reportParameters={reportParameters} />
    </Fragment>
  );
};

export default LSCReportingReports;